import store from '@/store';
import _ from 'lodash';
const packageConfig = require('../../package.json');

export default function(multianalytics) {
  return {
    eventRegisterStep5() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('EVENT_REGISTER_STEP_5');
        return;
      }

      const traits = this.getCommonTraits();

      multianalytics.trackEvent({
        action: 'EVENT_REGISTER_STEP_5',
        properties: traits
      });
    },
    eventRegisterStep4() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('EVENT_REGISTER_STEP_4');
        return;
      }

      const traits = this.getCommonTraits();

      multianalytics.trackEvent({
        action: 'EVENT_REGISTER_STEP_4',
        properties: traits
      });
    },
    eventRegisterStep3() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('EVENT_REGISTER_STEP_3');
        return;
      }

      const traits = this.getCommonTraits();

      multianalytics.trackEvent({
        action: 'EVENT_REGISTER_STEP_3',
        properties: traits
      });
    },
    eventRegisterStep2() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('EVENT_REGISTER_STEP_2');
        return;
      }

      const traits = this.getCommonTraits();

      multianalytics.trackEvent({
        action: 'EVENT_REGISTER_STEP_2',
        properties: traits
      });
    },
    eventRegisterStep1Email() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('EVENT_REGISTER_STEP_1_EMAIL');
        return;
      }

      multianalytics.trackEvent({
        action: 'EVENT_REGISTER_STEP_1_EMAIL'
      });
    },
    eventRegisterStep1() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('EVENT_REGISTER_STEP_1');
        return;
      }

      multianalytics.trackEvent({
        action: 'EVENT_REGISTER_STEP_1'
      });
    },
    actionBuy(params) {
      if (process.env.NODE_ENV === 'development') {
        // console.log('ACTION_BUY');
        return;
      }

      const traits = this.getCommonTraits();

      const newTraits = _.merge(traits, params);

      newTraits.currency = store.state.countrySelected.currency.iso;

      multianalytics.trackEvent({
        action: 'ACTION_BUY',
        properties: newTraits
      });
    },
    actionBooking() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('ACTION_BOOKING');
        return;
      }

      const traits = this.getCommonTraits();

      multianalytics.trackEvent({
        action: 'ACTION_BOOKING',
        properties: traits
      });
    },
    login() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('Identify');
        // console.log('ACTION_LOGIN');
        return;
      }
      const traits = this.getUserTraits();
      const commonTraits = this.getCommonTraits(traits);
      this.innerIdentify(traits, false);

      multianalytics.trackEvent({
        action: 'ACTION_LOGIN',
        properties: commonTraits
      });
    },
    loginNewUser() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('Identify');
        // console.log('ACTION_REGISTER');
        // console.log('ACTION_LOGIN');
        return;
      }
      const traits = this.getUserTraits();
      const commonTraits = this.getCommonTraits(traits);
      this.innerIdentify(traits, true);

      multianalytics.trackEvent({
        action: 'ACTION_LOGIN',
        properties: commonTraits
      });
    },
    logout() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('ACTION_LOGOUT');
        return;
      }
      multianalytics.trackEvent({
        action: 'ACTION_LOGOUT'
      });

      multianalytics.reset();
    },

    updateUserProperties() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('setUserProperties');
        return;
      }
      const traits = this.getUserTraits();

      this.innerIdentify(traits, false);
    },
    identify() {
      if (process.env.NODE_ENV === 'development') {
        // console.log('Identify');
        return;
      }

      if (!store.isLogged) {
        return;
      }

      const traits = this.getUserTraits();

      this.innerIdentify(traits, false);
    },
    getUserTraits() {
      let user = store.state.user;
      let country = store.state.countrySelected;
      let city = store.state.citySelected;
      let userId = user.id.toString();
      if (country.code !== 'ES') {
        userId = `${country.code}_${user.id}`;
      }

      return {
        user: user,
        country: country,
        city: city,
        userId: userId
      };
    },

    getCommonTraits() {
      const traits = this.getUserTraits();

      return this.convertToCommonTratis(traits);
    },

    convertToCommonTratis(traits) {
      const user = traits.user;
      const userId = traits.userId;
      const country = traits.country;
      const city = traits.city;

      return {
        userId: userId,
        name: user.name,
        email: user.username,
        phone: `${user.prefix}${user.phone}`,
        avatar: user.image,
        balance: user.balance.total,
        status: user.status,
        isNoob: user.isNoob,
        messageId: '',
        wspCountry: country.code,
        wspCity: city.code,
        webpAppVersion: packageConfig.version
      };
    },

    innerIdentify(traits, isNewUser) {
      const commonTraits = this.convertToCommonTratis(traits);

      if (isNewUser) {
        multianalytics.setAlias(commonTraits.userId);
      }
      multianalytics.identify({
        userId: commonTraits.userId,
        options: commonTraits
      });

      // multianalytics.setUserProperties(commonTraits);
    }
  };
}
